    (() => {
      if (customElements.get('store-email-popup')) return;

      const COOKIE = 'store_email_popup';
      const SESSION_KEY = 'store_email_popup_seen';
      const SESSION_START = 'store_email_popup_start';
      const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

      // Common misspellings of big email providers. A typo means the code never arrives and the
      // address bounces, which hurts deliverability for everyone on the list.
      const DOMAIN_FIXES = {
        'gamil.com': 'gmail.com', 'gmial.com': 'gmail.com', 'gmai.com': 'gmail.com', 'gmal.com': 'gmail.com',
        'gmaill.com': 'gmail.com', 'gnail.com': 'gmail.com', 'gmsil.com': 'gmail.com', 'gmali.com': 'gmail.com',
        'gmail.co': 'gmail.com', 'gmail.con': 'gmail.com', 'gmail.cm': 'gmail.com', 'gmail.om': 'gmail.com',
        'gmail.comm': 'gmail.com', 'gmail.cmo': 'gmail.com', 'gmail.vom': 'gmail.com', 'gmail.xom': 'gmail.com',
        'googlemail.co': 'googlemail.com', 'hotmial.com': 'hotmail.com', 'hotmal.com': 'hotmail.com',
        'hotmai.com': 'hotmail.com', 'hotamil.com': 'hotmail.com', 'homail.com': 'hotmail.com', 'hotmail.co': 'hotmail.com',
        'hotmail.con': 'hotmail.com', 'hotmial.co.uk': 'hotmail.co.uk', 'hotmail.co.um': 'hotmail.co.uk',
        'yaho.com': 'yahoo.com', 'yahooo.com': 'yahoo.com', 'yhoo.com': 'yahoo.com', 'yahoo.co': 'yahoo.com',
        'yahoo.con': 'yahoo.com', 'yaho.co.uk': 'yahoo.co.uk', 'outlok.com': 'outlook.com', 'outllok.com': 'outlook.com',
        'outlook.co': 'outlook.com', 'outlook.con': 'outlook.com', 'iclod.com': 'icloud.com', 'icoud.com': 'icloud.com',
        'iclould.com': 'icloud.com', 'icloud.co': 'icloud.com', 'icloud.con': 'icloud.com', 'live.co': 'live.co.uk',
        'btinternet.co': 'btinternet.com', 'aol.co': 'aol.com',
      };
      const DISPOSABLE = /(^|\.)(mailinator|guerrillamail|10minutemail|tempmail|temp-mail|yopmail|trashmail|sharklasers|getnada|throwawaymail|maildrop|dispostable|fakeinbox)\./i;

      const suggestFor = (email) => {
        const at = email.lastIndexOf('@');
        if (at < 1) return null;
        const domain = email.slice(at + 1).toLowerCase();
        let fixed = DOMAIN_FIXES[domain];
        if (!fixed && /\.(con|cmo|comm|vom|xom)$/.test(domain)) fixed = domain.replace(/\.[a-z]+$/, '.com');
        return fixed && fixed !== domain ? `${email.slice(0, at)}@${fixed}` : null;
      };

      const getCookie = (name) => {
        const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
      };
      const setCookie = (name, value, days) => {
        document.cookie = `${name}=${encodeURIComponent(value)}; max-age=${Math.round(days * 86400)}; path=/; SameSite=Lax`;
      };
      const store = {
        get(storage, key) { try { return window[storage].getItem(key); } catch (e) { return null; } },
        set(storage, key, value) { try { window[storage].setItem(key, value); } catch (e) {} },
      };

      class StoreEmailPopup extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');
          this.form = this.querySelector('[data-sp-form]');
          this.errorEl = this.querySelector('[data-sp-error]');
          this.emailInput = this.form.querySelector('input[name="email"]');
          this.submitBtn = this.form.querySelector('[type="submit"]');
          this.cfg = this.dataset;
          this.designMode = this.cfg.designMode === 'true' || Boolean(window.Shopify && window.Shopify.designMode);

          this.querySelectorAll('[data-sp-close]').forEach((btn) => btn.addEventListener('click', () => this.close()));
          this.dialog.addEventListener('cancel', (event) => { event.preventDefault(); this.close(); });
          this.dialog.addEventListener('click', (event) => { if (event.target === this.dialog) this.close(); });
          this.form.addEventListener('submit', (event) => this.onSubmit(event));
          this.nameInput = this.form.querySelector('input[name="firstname"]');
          this.suggestEl = this.querySelector('[data-sp-suggest]');
          this.suggestYes = this.querySelector('[data-sp-suggest-yes]');
          this.querySelector('[data-sp-suggest-no]')?.addEventListener('click', () => {
            this.acceptedEmail = this.emailInput.value.trim();
            this.hideSuggestion();
            this.form.requestSubmit();
          });
          this.suggestYes?.addEventListener('click', () => {
            this.emailInput.value = this.suggestYes.textContent;
            this.hideSuggestion();
            this.form.requestSubmit();
          });
          [this.emailInput, this.nameInput].forEach((input) => input?.addEventListener('input', () => this.clearError()));
          this.querySelector('[data-sp-copy]')?.addEventListener('click', (event) => this.copyCode(event.currentTarget));

          if (this.designMode) {
            this.bindEditor();
            return;
          }
          if (!this.shouldRun()) return;
          this.scheduleTriggers();
        }

        disconnectedCallback() {
          this.teardownTriggers();
          this.lockScroll(false);
          if (this.editorHandlers) {
            Object.entries(this.editorHandlers).forEach(([type, fn]) => document.removeEventListener(type, fn));
          }
        }

        /* ---------- when to show ---------- */

        shouldRun() {
          const params = new URLSearchParams(location.search);
          this.forced = params.get('sp_popup') === '1';
          if (this.forced) return true;

          if (getCookie(COOKIE)) return false;
          if (store.get('sessionStorage', SESSION_KEY)) return false;
          if (this.cfg.mobile !== 'true' && window.matchMedia('(max-width: 749px)').matches) return false;

          // People arriving from our own emails are already on the list.
          const source = (params.get('utm_source') || '').toLowerCase();
          const medium = (params.get('utm_medium') || '').toLowerCase();
          if (medium === 'email' || source.includes('activecampaign') || source.includes('klaviyo')) return false;
          if (params.get('_kx')) return false; // Klaviyo email click-through

          // Pages that already carry an ActiveCampaign sign-up form.
          if (document.querySelector('form[action*="activehosted.com/proc.php"]')) return false;
          return true;
        }

        scheduleTriggers() {
          const delayMs = this.forced ? 600 : Math.max(0, Number(this.cfg.delay || 0)) * 1000;

          // The delay counts time across the whole visit, not just this page.
          let start = Number(store.get('sessionStorage', SESSION_START));
          if (!start) {
            start = Date.now();
            store.set('sessionStorage', SESSION_START, String(start));
          }
          const remaining = Math.max(this.forced ? delayMs : 0, delayMs - (Date.now() - start));
          this.timer = window.setTimeout(() => this.requestOpen(), remaining);

          const desktop = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
          if (this.cfg.exitIntent === 'true' && desktop && !this.forced) {
            this.pageStart = Date.now();
            this.onMouseOut = (event) => {
              if (event.relatedTarget || event.clientY > 12) return;
              if (Date.now() - this.pageStart < 4000) return;
              this.requestOpen();
            };
            document.addEventListener('mouseout', this.onMouseOut);
          }
        }

        teardownTriggers() {
          window.clearTimeout(this.timer);
          window.clearTimeout(this.retryTimer);
          if (this.onMouseOut) document.removeEventListener('mouseout', this.onMouseOut);
        }

        // Wait politely if the cookie banner, cart drawer or another modal is open.
        // The cookie banner gets 20 seconds; after that the popup shows anyway.
        isBusy() {
          if (document.hidden) return true;
          const consent = document.getElementById('shopify-pc__banner');
          const consentWaited = Date.now() - this.waitStart > 20000;
          if (!consentWaited && consent && consent.offsetParent !== null && getComputedStyle(consent).visibility !== 'hidden') return true;
          const otherDialog = [...document.querySelectorAll('dialog[open]')].some((d) => d !== this.dialog);
          if (otherDialog) return true;
          if (document.querySelector('cart-drawer[open], details[open].menu-drawer-container, .drawer.active')) return true;
          return false;
        }

        requestOpen() {
          if (this.dialog.open || this.hasOpened) return;
          this.waitStart = this.waitStart || Date.now();
          if (this.isBusy()) {
            window.clearTimeout(this.retryTimer);
            this.retryTimer = window.setTimeout(() => this.requestOpen(), 2000);
            return;
          }
          this.hasOpened = true;
          this.teardownTriggers();
          if (!this.forced) store.set('sessionStorage', SESSION_KEY, '1');
          this.open();
        }

        /* ---------- open / close ---------- */

        open() {
          if (this.dialog.open) return;
          this.lastFocus = document.activeElement;
          this.dialog.showModal();
          this.lockScroll(true);
          requestAnimationFrame(() => requestAnimationFrame(() => this.dialog.classList.add('is-visible')));

          const desktop = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
          if (desktop) {
            window.setTimeout(() => this.form.querySelector('input:not(.sp-popup__hp)')?.focus({ preventScroll: true }), 50);
          } else {
            this.dialog.querySelector('.sp-popup__close').focus({ preventScroll: true });
          }
          this.track('store_email_popup_viewed');
          this.preconnect();
        }

        // Open the connection to the email provider early so the sign-up request starts faster.
        preconnect() {
          const host = this.cfg.provider === 'activecampaign'
            ? (this.cfg.acAccount ? `https://${this.cfg.acAccount}.activehosted.com` : '')
            : 'https://a.klaviyo.com';
          if (this.preconnected || !host) return;
          this.preconnected = true;
          const link = Object.assign(document.createElement('link'), {
            rel: 'preconnect',
            href: host,
            crossOrigin: 'anonymous',
          });
          document.head.appendChild(link);
        }

        close({ remember = true } = {}) {
          if (!this.dialog.open) return;
          if (remember && !this.designMode && !this.subscribed) {
            setCookie(COOKIE, 'closed', Number(this.cfg.dismissDays || 14));
            this.track('store_email_popup_closed');
          }
          this.dialog.classList.remove('is-visible');
          const finish = () => {
            if (!this.dialog.open) return;
            this.dialog.close();
            this.lockScroll(false);
            this.lastFocus?.focus?.({ preventScroll: true });
          };
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (reduced) finish();
          else window.setTimeout(finish, 320);
        }

        // Only lock on phones, where the bottom sheet would otherwise scroll the page behind it.
        lockScroll(lock) {
          if (lock && !window.matchMedia('(max-width: 749px)').matches) return;
          document.documentElement.style.overflow = lock ? 'hidden' : '';
        }

        /* ---------- submit ---------- */

        async onSubmit(event) {
          event.preventDefault();
          if (this.submitBtn.getAttribute('aria-busy') === 'true') return;

          // Tidy the name for AC personalisation. If someone types their full name, the first word
          // becomes First name and the rest Last name, so emails greet them as "Joe", not "Joe Alley".
          const capitalise = (word) => word.charAt(0).toUpperCase() + word.slice(1);
          const [first = '', ...rest] = (this.nameInput?.value || '').trim().split(/\s+/).filter(Boolean);
          const firstName = first ? capitalise(first) : '';
          const lastName = rest.map(capitalise).join(' ');
          if (this.nameInput?.required && !firstName) {
            this.showError('Please enter your first name.', this.nameInput);
            this.nameInput.focus();
            return;
          }
          const email = this.emailInput.value.trim();
          if (!EMAIL_RE.test(email)) {
            this.showError('Please enter a valid email address.');
            this.emailInput.focus();
            return;
          }
          if (DISPOSABLE.test(email.split('@')[1] || '')) {
            this.showError('Please use your usual email address so your code and emails reach you.');
            this.emailInput.focus();
            return;
          }
          const suggestion = suggestFor(email);
          if (suggestion && this.acceptedEmail !== email) {
            this.showSuggestion(suggestion);
            return;
          }

          // Bots fill hidden fields. Show them success and send nothing.
          if (this.form.company_website.value) {
            this.showSuccess();
            return;
          }

          if (this.cfg.acReady !== 'true') {
            this.showError(
              this.designMode
                ? 'Add your Klaviyo company ID and list ID (or ActiveCampaign form details) in this section’s settings to switch on sign-ups.'
                : 'Sorry, sign-up is not available right now. Please try again later.'
            );
            return;
          }

          this.clearError();
          this.submitBtn.setAttribute('aria-busy', 'true');
          try {
            // The provider can take a few seconds to answer. Show success after 1.2s at most and let the
            // request finish in the background; a quick error reply still shows as an error.
            const request = this.cfg.provider === 'activecampaign'
              ? this.sendToActiveCampaign(email, firstName, lastName)
              : this.sendToKlaviyo(email, firstName, lastName);
            request.catch(() => {});
            await Promise.race([request, new Promise((resolve) => window.setTimeout(resolve, 1200))]);
            this.subscribed = true;
            setCookie(COOKIE, 'subscribed', 365);
            this.applyDiscount();
            this.track('store_email_popup_subscribed');
            this.showSuccess(firstName);
          } catch (error) {
            this.showError(error?.message || 'Something went wrong. Please try again.');
          } finally {
            this.submitBtn.removeAttribute('aria-busy');
          }
        }

        sendToActiveCampaign(email, firstName, lastName = '') {
          const { acAccount, acFormId, acFormU, acFormOr } = this.cfg;
          const params = new URLSearchParams({
            u: acFormU, f: acFormId, s: '', c: '0', m: '0', act: 'sub', v: '2', email,
          });
          if (acFormOr) params.set('or', acFormOr);
          if (firstName) params.set('firstname', firstName);
          if (lastName) params.set('lastname', lastName);
          const base = `https://${acAccount}.activehosted.com/proc.php`;

          // ActiveCampaign's own embeds use JSONP, which tells us if the sign-up worked.
          return new Promise((resolve, reject) => {
            const prevThanks = window._show_thank_you;
            const prevError = window._show_error;
            let settled = false;
            const script = document.createElement('script');

            const cleanUp = () => {
              window._show_thank_you = prevThanks;
              window._show_error = prevError;
              window.clearTimeout(timeout);
              script.remove();
            };
            const done = (ok, message) => {
              if (settled) return;
              settled = true;
              cleanUp();
              ok ? resolve() : reject(new Error(message));
            };
            // If the JSONP call is blocked (some ad blockers do this), post the form directly instead.
            const fallback = () => {
              if (settled) return;
              fetch(base, { method: 'POST', mode: 'no-cors', body: params })
                .then(() => done(true))
                .catch(() => done(false, 'We could not reach our mailing list. Please try again.'));
            };

            window._show_thank_you = (...args) => {
              const [id, , trackcmpUrl] = args;
              if (String(id) !== String(acFormId)) return prevThanks?.apply(window, args);
              // AC's site-tracking cookie is marketing tracking, so only load it with consent.
              const marketingOk = window.Shopify?.customerPrivacy?.marketingAllowed?.() === true;
              if (trackcmpUrl && marketingOk) {
                const tracker = document.createElement('script');
                tracker.src = trackcmpUrl;
                tracker.async = true;
                document.head.appendChild(tracker);
              }
              done(true);
            };
            window._show_error = (...args) => {
              const [id, message] = args;
              if (String(id) !== String(acFormId)) return prevError?.apply(window, args);
              const text = String(message || '').replace(/<[^>]*>/g, '').trim();
              done(false, text || 'Something went wrong. Please try again.');
            };

            const timeout = window.setTimeout(fallback, 8000);
            script.async = true;
            script.onerror = fallback;
            script.src = `${base}?${params.toString()}&jsonp=true`;
            document.head.appendChild(script);
          });
        }

        // Klaviyo client API: public company ID only (safe in the browser). The list's own settings
        // (single or double opt-in) and the flows triggered by that list decide what happens next.
        async sendToKlaviyo(email, firstName, lastName = '') {
          const { klCompany, klList, klSource } = this.cfg;
          const attributes = { email };
          if (firstName) attributes.first_name = firstName;
          if (lastName) attributes.last_name = lastName;
          const body = {
            data: {
              type: 'subscription',
              attributes: {
                custom_source: klSource || 'Website pop-up',
                profile: { data: { type: 'profile', attributes } },
              },
              relationships: { list: { data: { type: 'list', id: klList } } },
            },
          };
          const response = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(klCompany)}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/vnd.api+json', accept: 'application/vnd.api+json', revision: '2024-10-15' },
            body: JSON.stringify(body),
          });
          if (!response.ok && response.status !== 202) {
            throw new Error('We could not reach our mailing list. Please try again.');
          }
        }

        applyDiscount() {
          const code = this.cfg.code;
          if (!code || this.cfg.autoApply !== 'true') return;
          fetch(`${window.Shopify?.routes?.root || '/'}discount/${encodeURIComponent(code)}`, { credentials: 'same-origin' }).catch(() => {});
        }

        /* ---------- UI states ---------- */

        showSuccess(firstName = '') {
          this.querySelector('[data-sp-step="form"]').hidden = true;
          const success = this.querySelector('[data-sp-step="success"]');
          const title = success.querySelector('[data-sp-success-title]');
          // "{name}" in the heading becomes the visitor's first name, or disappears if there isn't one.
          if (title) title.textContent = title.textContent.replace(/\s*\{name\}/i, firstName ? ` ${firstName}` : '');
          success.hidden = false;
          this.dialog.setAttribute('aria-labelledby', `SpPopupSuccess-${this.cfg.sectionId}`);
          success.querySelector('[data-sp-success-title]')?.focus({ preventScroll: true });
        }

        showError(message, input = this.emailInput) {
          this.errorEl.textContent = message;
          this.errorEl.hidden = false;
          input?.setAttribute('aria-invalid', 'true');
        }

        showSuggestion(email) {
          this.clearError();
          this.suggestYes.textContent = email;
          this.suggestEl.hidden = false;
          this.suggestYes.focus({ preventScroll: true });
        }

        hideSuggestion() {
          if (this.suggestEl) this.suggestEl.hidden = true;
        }

        clearError() {
          this.hideSuggestion();
          this.errorEl.hidden = true;
          this.errorEl.textContent = '';
          [this.emailInput, this.nameInput].forEach((input) => input?.removeAttribute('aria-invalid'));
        }

        async copyCode(button) {
          const code = this.cfg.code;
          try {
            await navigator.clipboard.writeText(code);
          } catch (e) {
            const temp = Object.assign(document.createElement('textarea'), { value: code });
            this.dialog.appendChild(temp);
            temp.select();
            document.execCommand('copy');
            temp.remove();
          }
          const original = button.textContent;
          button.textContent = button.dataset.copiedLabel || 'Copied';
          window.setTimeout(() => (button.textContent = original), 2000);
        }

        track(name) {
          try { window.Shopify?.analytics?.publish?.(name, { section: this.cfg.sectionId }); } catch (e) {}
        }

        /* ---------- theme editor ---------- */

        bindEditor() {
          const id = this.cfg.sectionId;
          const isThis = (event) => this.isConnected && event.detail && event.detail.sectionId === id;
          this.editorHandlers = {
            'shopify:section:select': (event) => { if (isThis(event)) this.open(); },
            'shopify:section:deselect': (event) => { if (isThis(event)) this.close({ remember: false }); },
            // Changing a setting re-renders the section; reopen so the preview stays visible.
            'shopify:section:load': (event) => { if (isThis(event)) this.open(); },
          };
          Object.entries(this.editorHandlers).forEach(([type, fn]) => document.addEventListener(type, fn));
        }
      }

      customElements.define('store-email-popup', StoreEmailPopup);
    })();
